import { Component, OnInit } from '@angular/core';
import { ExpressService } from './services/express.service';
import { SidePanelService } from '../shared/services/side-pannel/side-pannel.service';

@Component({
  selector: 'app-express',
  templateUrl: './express.component.html',
  styleUrls: ['./express.component.scss']
})
export class ExpressComponent implements OnInit {
  accessRoles: any;
  searchText: string = '';
  constructor(
    public sidePanelService:SidePanelService,
    public expressService:ExpressService
  ) { 
    this.sidePanelService.initSideDrawer('express');
    this.accessRoles = JSON.parse(localStorage.getItem('access'));
  }

  ngOnInit(): void {
  }

  onSearchChange(searchTerm: string) {
    this.expressService.headerSearchEventEmitter.emit(searchTerm);
  }

}
